import ShareLinkSet from '@/components/ShareLinkSet';
import useShortLink from '@/components/ShareLinkSet/hooks/useShortLink';
import useShareReferral from '@/ducks/share/hooks/useShareReferral';

type TProps = {
  autoFocus?: boolean;
  onClick?: () => void;
  reservationNumber: string;
};

const ShareReferralLinks = ({ autoFocus, onClick, reservationNumber }: TProps) => {
  const { link, sailingData } = useShareReferral(reservationNumber);
  const shortLink = useShortLink(link, true);
  return (
    <ShareLinkSet
      autoFocus={autoFocus}
      className="ShareReferralLinks"
      isAltIcons
      link={shortLink}
      onShare={onClick}
      sailingData={sailingData}
    />
  );
};

export default ShareReferralLinks;
